import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { useSelector } from "react-redux";

import Oauth from "./Oauth";

const PageWrapper = styled(Box)(({ theme }) => ({
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: 16,
  boxSizing: "border-box",
  position: "relative",
  overflow: "hidden",
  background: `radial-gradient(circle at 15% 20%, ${theme.palette.login.pageGlowRed} 0, transparent 40%),
    radial-gradient(circle at 85% 80%, ${theme.palette.login.pageGlowNavy} 0, transparent 45%),
    linear-gradient(135deg, ${theme.palette.login.pageGradientStart} 0%, ${theme.palette.login.pageGradientEnd} 100%)`,
}));

const StyledBox = styled(Box)(({ theme }) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  width: "100%",
  maxWidth: 420,
  backgroundColor: theme.palette.login.cardBg,
  borderRadius: 20,
  boxShadow: `0 24px 48px -12px ${theme.palette.login.cardShadow}, 0 4px 12px ${theme.palette.login.cardShadowSoft}`,
  padding: "48px 36px 64px",
  boxSizing: "border-box",
  overflow: "hidden",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: 5,
    background: `linear-gradient(90deg, ${theme.palette.login.navy} 0%, ${theme.palette.login.navy} 60%, ${theme.palette.login.red} 100%)`,
  },
}));

const Header = React.memo(() => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      width="100%"
      textAlign="center"
    >
      <Box
        component="img"
        sx={{ width: "68%", maxWidth: 260, mb: 4 }}
        alt="JSW logo"
        src="/assets/logo.svg"
      />
      <Box
        sx={{
          width: 48,
          height: 3,
          borderRadius: 2,
          backgroundColor: "login.red",
          mb: 3,
        }}
      />
      <Typography fontSize={15} color="login.subtitle" mb={4}>
        Please sign-in{" "}
        <Typography
          component="span"
          sx={{
            display: "inline-block",
            fontSize: 13,
            fontWeight: 700,
            color: "login.navy",
            backgroundColor: "login.badgeBg",
            borderRadius: "6px",
            px: 1,
            py: 0.25,
            letterSpacing: 0.5,
          }}
        >
          ERP
        </Typography>{" "}
        using your account
      </Typography>
    </Box>
  );
});

const Login = () => {
  const navigation = useNavigate();
  const login = useSelector((state) => state.isLoggedIn);

  const onLogin = () => {
    navigation("/dashboard");
  };

  useEffect(() => {
    if (login.value) {
      onLogin();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PageWrapper>
      <StyledBox>
        <Header />
        <Oauth />
      </StyledBox>
    </PageWrapper>
  );
};

export default Login;
